import { render, staticRenderFns } from "./FirmaDocumenti.vue?vue&type=template&id=0dcdce18&"
import script from "./FirmaDocumenti.vue?vue&type=script&lang=js&"
export * from "./FirmaDocumenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports